(function(){
  if(window.__lnScriptsLoaded)return; window.__lnScriptsLoaded=true; /* varias secciones cargan este archivo: solo se inicia una vez */
  function initReveal(){
    var els=document.querySelectorAll('.ln-reveal');
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('ln-visible')});return}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('ln-visible');io.unobserve(x.target)}})},{threshold:.12});
    els.forEach(function(e,i){e.style.setProperty('--i',i%4);io.observe(e)});
  }
  function initGaleria(){
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-ln-gal]').forEach(function(g){
      var main=g.querySelector('[data-ln-main]'), vid=g.querySelector('[data-ln-video]');
      var ths=[].slice.call(g.querySelectorAll('[data-ln-th]'));
      var imgs=ths.filter(function(x){return x.getAttribute('data-type')!=='video'});
      var auto=g.getAttribute('data-ln-auto')==='true', iv=(+g.getAttribute('data-ln-int'))||4000;
      var timer=null, hover=false, pausedUntil=0, showingVideo=false;
      function show(b){
        ths.forEach(function(x){x.classList.remove('on')}); b.classList.add('on');
        if(b.getAttribute('data-type')==='video' && vid){
          showingVideo=true; stop();
          vid.src=b.getAttribute('data-src'); vid.poster=b.getAttribute('data-poster')||'';
          main.hidden=true; vid.hidden=false; var p=vid.play(); if(p&&p.catch)p.catch(function(){});
        }else{
          if(vid){vid.pause();vid.hidden=true}
          showingVideo=false; main.hidden=false;
          var src=b.getAttribute('data-src');
          if(main.getAttribute('src')===src)return;
          var pre=new Image(); pre.onload=function(){main.style.opacity=0;setTimeout(function(){main.src=src;main.style.opacity=1},220)}; pre.onerror=function(){main.src=src}; pre.src=src;
        }
      }
      function next(){
        var i=imgs.findIndex(function(x){return x.classList.contains('on')});
        show(imgs[(i+1)%imgs.length]);
      }
      function stop(){ if(timer){clearInterval(timer);timer=null} }
      function start(){
        stop(); if(!auto||reduce||imgs.length<2||showingVideo)return;
        timer=setInterval(function(){ if(document.hidden||hover||Date.now()<pausedUntil)return; next() },iv);
      }
      ths.forEach(function(b){ b.addEventListener('click',function(){ show(b); pausedUntil=Date.now()+iv; start() }); });
      g.addEventListener('mouseenter',function(){hover=true});
      g.addEventListener('mouseleave',function(){hover=false});
      g.addEventListener('touchstart',function(){pausedUntil=Date.now()+iv*2},{passive:true});
      g.__lnNext=next;
      start();
    });
  }
  function fmt(c,cur){
    try{return new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:cur}).format(c/100)}catch(e){return (c/100).toFixed(2)+' '+cur}
  }
  function initProducto(){
    var root=document.querySelector('[data-ln-prod]');
    if(!root)return;
    var data=JSON.parse(root.querySelector('[data-ln-json]').textContent);
    var cur=data.currency, variants=data.variants;
    var idIn=root.querySelector('[name=id]'), qtyIn=root.querySelector('[name=quantity]');
    var btn=root.querySelector('[data-ln-buy]'), precio=root.querySelector('[data-ln-precio]'), base=root.querySelector('[data-ln-base]');
    var form=root.querySelector('form'); var sel={}; var pack=1;
    variants[0].options.forEach(function(o,i){sel[i]=o});
    root.querySelectorAll('[data-ln-opt]').forEach(function(box){
      var idx=+box.getAttribute('data-ln-opt');
      box.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click',function(){
          sel[idx]=b.getAttribute('data-v');
          box.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b)});
          update();
        });
      });
    });
    function packUnits(){ return root.querySelector('.ln-units[data-units="'+pack+'"]'); }
    root.querySelectorAll('.ln-pack input').forEach(function(r){
      r.addEventListener('change',function(){
        pack=+r.value;
        root.querySelectorAll('.ln-pack').forEach(function(p){p.classList.toggle('on',p.contains(r)&&r.checked)});
        root.querySelectorAll('.ln-units').forEach(function(u){u.hidden=(+u.getAttribute('data-units')!==pack)});
        var ct=root.querySelector('[data-ln-ct]'); if(ct)ct.textContent=pack>1?ct.getAttribute('data-tn'):ct.getAttribute('data-t1');
        qtyIn.value=r.value; update();
      });
    });
    // color por unidad: la primera unidad cambia la foto de la galería
    root.querySelectorAll('.ln-units').forEach(function(u){
      var first=u.querySelector('select[data-ln-unit]');
      if(first)first.addEventListener('change',function(){
        var op=first.options[first.selectedIndex], mid=op.getAttribute('data-mid'), color=op.getAttribute('data-color');
        var th=(mid&&document.querySelector('[data-ln-th][data-mid="'+mid+'"]'))||document.querySelector('[data-ln-th][data-alt="'+color+'"]'); if(th)th.click();
      });
    });
    root.querySelectorAll('.ln-sw').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(btn.disabled)return;
        var row=btn.closest('.ln-unit'), sel=row.querySelector('select[data-ln-unit]');
        sel.value=btn.getAttribute('data-v');
        row.querySelectorAll('.ln-sw').forEach(function(b){b.classList.toggle('on',b===btn)});
        var nm=row.querySelector('.ln-unit__sel'); if(nm)nm.textContent=btn.getAttribute('data-color');
        sel.dispatchEvent(new Event('change'));
      });
    });
    var bar=document.querySelector('[data-ln-sticky]');
    function syncSticky(ok){
      if(!bar)return;
      var tot=root.querySelector('.ln-pack.on [data-ln-total]'), org=root.querySelector('.ln-pack.on [data-ln-orig]');
      var pr=bar.querySelector('[data-ln-sticky-price]'), so=bar.querySelector('[data-ln-sticky-orig]');
      if(tot)pr.textContent=tot.textContent;
      if(so)so.textContent=(org&&org.textContent)?org.textContent:'';
      var u=packUnits(), colors=[], mid=null;
      if(u){ [].slice.call(u.querySelectorAll('select')).forEach(function(s,i){var op=s.options[s.selectedIndex]; colors.push(op.getAttribute('data-color')); if(i===0)mid=op.getAttribute('data-mid')}) }
      var lab=root.querySelector('.ln-pack.on .ln-pack__t'); var pk=lab?lab.childNodes[0].textContent.trim():'';
      bar.querySelector('[data-ln-sticky-sel]').textContent=[pk].concat(colors.length?[colors.join(', ')]:[]).filter(Boolean).join(' · ');
      var th=mid&&document.querySelector('[data-ln-th][data-mid="'+mid+'"]'); var im=bar.querySelector('[data-ln-sticky-img]');
      if(th&&th.dataset.src)im.src=th.dataset.src;
      var bb=bar.querySelector('[data-ln-sticky-buy]'); if(btn){bb.disabled=btn.disabled;bb.textContent=btn.textContent}
    }
    if(bar&&btn){
      bar.querySelector('[data-ln-sticky-buy]').addEventListener('click',function(){btn.click()});
      var visible=false;
      function check(){
        var pasado=btn.getBoundingClientRect().bottom<0;
        if(pasado&&!visible){visible=true;bar.hidden=false;void bar.offsetWidth;bar.classList.add('on')}
        else if(!pasado&&visible){visible=false;bar.classList.remove('on');setTimeout(function(){if(!visible)bar.hidden=true},380)}
      }
      window.addEventListener('scroll',check,{passive:true});
      window.addEventListener('resize',check); check();
    }
    function current(){
      var u=packUnits(); if(u){var s0=u.querySelector('select'); if(s0){var id=+s0.value; var v=variants.find(function(x){return x.id===id}); if(v)return v}}
      return variants.find(function(v){return v.options.every(function(o,i){return o===sel[i]})})||variants[0];
    }
    function update(){
      var v=current(); idIn.value=v.id;
      if(precio&&precio.getAttribute('data-fixed')!=='1'){var d=+precio.getAttribute('data-d')||0; precio.textContent=fmt(Math.round(v.price*(1-d/100)),cur); if(base)base.textContent=fmt(v.price,cur)}
      root.querySelectorAll('[data-ln-total]').forEach(function(t){
        if(t.getAttribute('data-fixed')==='1')return;
        var q=+t.getAttribute('data-q'), d=+t.getAttribute('data-d')||0;
        t.textContent=fmt(Math.round(v.price*q*(1-d/100)),cur);
      });
      root.querySelectorAll('[data-ln-orig]').forEach(function(t){
        if(t.getAttribute('data-fixed')==='1')return;
        var q=+t.getAttribute('data-q'), d=+t.getAttribute('data-d')||0;
        t.textContent=d>0?fmt(v.price*q,cur):'';
      });
      var u=packUnits(); var ok=v.available;
      if(u){ok=[].slice.call(u.querySelectorAll('select')).every(function(s){var id=+s.value;var x=variants.find(function(y){return y.id===id});return x&&x.available})}
      if(btn){btn.disabled=!ok;btn.textContent=ok?btn.getAttribute('data-txt'):btn.getAttribute('data-agotado')}
      syncSticky(ok);
    }
    root.querySelectorAll('select[data-ln-unit]').forEach(function(s){s.addEventListener('change',update)});
    // añadir al carrito: cada unidad con su color
    if(form && root.querySelector('.ln-units')){
      form.addEventListener('submit',function(e){
        var u=packUnits(); if(!u)return;
        e.preventDefault();
        var counts={}; u.querySelectorAll('select').forEach(function(s){counts[s.value]=(counts[s.value]||0)+1});
        var items=Object.keys(counts).map(function(id){return {id:+id,quantity:counts[id]}});
        var root_=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        var code='';
        if(pack===2||pack===3){
          var suf=cur==='EUR'?'':('-'+cur);
          if(cur==='EUR'||cur==='USD'||cur==='MXN')code='PACK'+pack+suf;
        }
        if(btn)btn.disabled=true;
        fetch(root_+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){if(!r.ok)throw new Error('add');return r.json()})
          .then(function(){ return fetch(root_+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({discount:code})}) })
          .then(function(){ if(btn)btn.disabled=false; if(window.mgCarrito){window.mgCarrito.open()} else {window.location.href=root_+'cart'} })
          .catch(function(){ if(btn)btn.disabled=false; idIn.value=items[0].id; qtyIn.value=pack; form.submit() });
      });
    }
    update();
  }
  function initAntesDespues(){
    document.querySelectorAll('[data-ln-ba]').forEach(function(w){
      var r=w.querySelector('.ln-ba__range');
      function set(){w.style.setProperty('--pos',r.value+'%')}
      r.addEventListener('input',set); set();
    });
  }
  function initVideos(){
    var vs=document.querySelectorAll('[data-ln-autoplay]'); if(!vs.length)return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(v){ if(reduce||v.dataset.manual)return; v.muted=true; var p=v.play(); if(p&&p.catch)p.catch(function(){}) }
    var io='IntersectionObserver' in window?new IntersectionObserver(function(en){en.forEach(function(x){
      var v=x.target; if(x.isIntersecting){go(v)} else v.pause();
    })},{threshold:.15}):null;
    vs.forEach(function(v){
      v.muted=true;
      if(io)io.observe(v); else go(v);
      v.addEventListener('loadeddata',function(){var r=v.getBoundingClientRect(); if(r.bottom>0&&r.top<window.innerHeight)go(v)});
      var b=v.parentElement.querySelector('[data-ln-vidbtn]');
      if(b)b.addEventListener('click',function(){
        if(v.paused){v.dataset.manual='';v.play();b.textContent='⏸'}else{v.dataset.manual='1';v.pause();b.textContent='▶'}
      });
    });
    document.addEventListener('visibilitychange',function(){ if(!document.hidden)vs.forEach(function(v){var r=v.getBoundingClientRect(); if(r.bottom>0&&r.top<window.innerHeight)go(v)}) });
  }
  function finEn(f,h,z){
    if(z.indexOf('/')<0)return new Date(f+'T'+h+z);
    try{
      var a=f.split('-'),b=h.split(':'),g=Date.UTC(+a[0],a[1]-1,+a[2],+b[0],+b[1],+(b[2]||0));
      var fm=new Intl.DateTimeFormat('en-US',{timeZone:z,hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit'});
      var off=function(t){var o={};fm.formatToParts(new Date(t)).forEach(function(x){o[x.type]=x.value});return Date.UTC(+o.year,o.month-1,+o.day,+o.hour,+o.minute,+o.second)-t};
      var t=g-off(g);t=g-off(t);return new Date(t);
    }catch(e){return new Date(NaN)}
  }
  function initCuentaAtras(){
    document.querySelectorAll('[data-ln-cd]').forEach(function(el){
      var f=el.getAttribute('data-fecha'),h=el.getAttribute('data-hora')||'23:59',z=el.getAttribute('data-zona')||'+00:00';
      var end=finEn(f,(h.length===5?h+':00':h),z);
      var ocultar=el.getAttribute('data-ocultar')==='true', fin=el.getAttribute('data-fin-texto');
      var bucle=el.getAttribute('data-bucle')==='true';
      if(isNaN(end.getTime())){el.hidden=true;return}
      var u={d:el.querySelector('[data-u=d]'),h:el.querySelector('[data-u=h]'),m:el.querySelector('[data-u=m]'),s:el.querySelector('[data-u=s]')};
      var t;
      function p(n){return n<10?'0'+n:''+n}
      function tick(){
        var ms=end.getTime()-Date.now();
        if(ms<=0 && bucle){
          // ha llegado a cero y está en bucle: se pone otro ciclo de 24h (o varios, si la pestaña llevaba cerrada más de un día)
          while(ms<=0){ end=new Date(end.getTime()+86400000); ms=end.getTime()-Date.now() }
        }
        if(ms<=0){
          clearInterval(t);
          if(ocultar){el.hidden=true}
          else{u.d.textContent=u.h.textContent=u.m.textContent=u.s.textContent='00'; var tt=el.querySelector('.ln-cd__t'); if(tt&&fin)tt.textContent=fin}
          return;
        }
        var s=Math.floor(ms/1000);
        u.d.textContent=p(Math.floor(s/86400)); u.h.textContent=p(Math.floor(s%86400/3600)); u.m.textContent=p(Math.floor(s%3600/60)); u.s.textContent=p(s%60);
      }
      tick(); t=setInterval(tick,1000);
    });
  }
  function initHeroSlider(){
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-ln-hs]').forEach(function(el){
      var slides=[].slice.call(el.querySelectorAll('.ln-hs__slide')), dots=[].slice.call(el.querySelectorAll('.ln-hs__dots button'));
      var auto=el.getAttribute('data-ln-auto')==='true', iv=(+el.getAttribute('data-ln-int'))||4000, i=0, hover=false, pausedUntil=0, timer=null;
      function go(n){
        i=(n+slides.length)%slides.length;
        slides.forEach(function(s,k){s.classList.toggle('on',k===i);s.tabIndex=k===i?0:-1});
        dots.forEach(function(d,k){d.classList.toggle('on',k===i)});
      }
      dots.forEach(function(d,k){d.addEventListener('click',function(e){e.preventDefault();go(k);pausedUntil=Date.now()+iv*2})});
      el.addEventListener('mouseenter',function(){hover=true});
      el.addEventListener('mouseleave',function(){hover=false});
      el.addEventListener('touchstart',function(){pausedUntil=Date.now()+iv*2},{passive:true});
      if(auto&&!reduce&&slides.length>1){
        timer=setInterval(function(){ if(document.hidden||hover||Date.now()<pausedUntil)return; go(i+1) },iv);
      }
    });
  }
  function initCarrito(){
    var root=document.getElementById('mg-cart');
    if(!root||root.__init)return; root.__init=true;
    var root_=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    var elItems=root.querySelector('[data-mg-items]'), elEmpty=root.querySelector('[data-mg-empty]');
    var elAddons=root.querySelector('[data-mg-addons]'), elFoot=root.querySelector('[data-mg-foot]');
    var elCount=root.querySelector('[data-mg-count]'), elSubtotal=root.querySelector('[data-mg-subtotal]');
    var elSave=root.querySelector('[data-mg-save]'), elSaveV=root.querySelector('[data-mg-save-v]');
    var elPay=root.querySelector('[data-mg-pay]'), elReserved=root.querySelector('[data-mg-reserved]'), elClock=root.querySelector('[data-mg-clock]');
    var addonToggles=[].slice.call(root.querySelectorAll('[data-mg-addon-toggle]'));
    var addonVariantIds=addonToggles.map(function(t){return +t.getAttribute('data-variant-id')});
    var timer=null, busy=false;
    var tRemove=root.getAttribute('data-t-remove')||'', tSave=root.getAttribute('data-t-save')||'';

    function money(cents,cur){return fmt(Math.round(cents),cur)}

    var cmpCache={}; // handle -> {variantId: compare_at_price en céntimos}
    function fetchCompareMap(cart){
      var handles=[];
      cart.items.forEach(function(it){
        var h=(it.handle||(it.url||'').split('/products/')[1]||'').split('?')[0].split('/')[0];
        if(h&&!cmpCache[h]&&handles.indexOf(h)<0)handles.push(h);
      });
      if(!handles.length)return Promise.resolve();
      return Promise.all(handles.map(function(h){
        return fetch(root_+'products/'+h+'.js').then(function(r){return r.ok?r.json():null}).then(function(p){
          var m={}; if(p&&p.variants)p.variants.forEach(function(v){m[v.id]=v.compare_at_price||0});
          cmpCache[h]=m;
        }).catch(function(){cmpCache[h]={}});
      }));
    }
    function renderWithCompare(cart){
      return fetchCompareMap(cart).then(function(){render(cart)});
    }

    function startTimer(){
      clearInterval(timer);
      if(!elClock)return;
      var left=300; // 5 minutos: no reserva stock de verdad, solo transmite urgencia
      function tick(){
        var m=Math.floor(left/60), s=left%60;
        elClock.textContent=(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
        if(left<=0){clearInterval(timer);return}
        left--;
      }
      tick(); timer=setInterval(tick,1000);
      if(elReserved)elReserved.hidden=false;
    }

    function render(cart){
      var cur=cart.currency;
      elCount.textContent=cart.item_count;
      var mainLines=[], addonLines={};
      cart.items.forEach(function(it,idx){
        if(addonVariantIds.indexOf(it.variant_id)>-1){addonLines[it.variant_id]={line:idx+1,item:it}}
        else mainLines.push({line:idx+1,item:it});
      });
      elEmpty.hidden=cart.item_count>0;
      elItems.hidden=cart.item_count===0;
      if(elAddons)elAddons.hidden=cart.item_count===0;
      if(elFoot)elFoot.hidden=cart.item_count===0;
      elItems.innerHTML='';
      mainLines.forEach(function(o){
        var it=o.item;
        var h=(it.handle||(it.url||'').split('/products/')[1]||'').split('?')[0].split('/')[0];
        var cmpUnit=(cmpCache[h]||{})[it.variant_id]||0;
        var origLine=Math.max(it.original_line_price,cmpUnit*it.quantity);
        var finalLine=it.final_line_price;
        var wrap=document.createElement('div'); wrap.className='mg-cart__item';
        var img=document.createElement('img'); img.src=it.image?(it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=200'):''; img.alt=it.product_title||''; img.loading='lazy';
        var body=document.createElement('div'); body.className='mg-cart__item-body';
        var top=document.createElement('div'); top.className='mg-cart__item-top';
        var title=document.createElement('div'); title.className='mg-cart__item-title'; title.textContent=it.product_title;
        var rm=document.createElement('button'); rm.type='button'; rm.className='mg-cart__item-rm'; rm.setAttribute('aria-label',tRemove);
        rm.innerHTML='<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m-8 0 1 12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1l1-12"/></svg>';
        rm.addEventListener('click',function(){changeLine(o.line,0)});
        top.appendChild(title); top.appendChild(rm);
        body.appendChild(top);
        if(it.variant_title && it.variant_title!=='Default Title'){
          var vv=document.createElement('div'); vv.className='mg-cart__item-variant'; vv.textContent=it.variant_title; body.appendChild(vv);
        }
        var qty=document.createElement('div'); qty.className='mg-cart__qty';
        var minus=document.createElement('button'); minus.type='button'; minus.textContent='−';
        var qn=document.createElement('span'); qn.textContent=it.quantity;
        var plus=document.createElement('button'); plus.type='button'; plus.textContent='+';
        minus.addEventListener('click',function(){changeLine(o.line,it.quantity-1)});
        plus.addEventListener('click',function(){changeLine(o.line,it.quantity+1)});
        qty.appendChild(minus); qty.appendChild(qn); qty.appendChild(plus);
        body.appendChild(qty);
        var pr=document.createElement('div'); pr.className='mg-cart__item-price';
        pr.appendChild(document.createTextNode(money(finalLine,cur)));
        if(origLine>finalLine){
          var s=document.createElement('s'); s.textContent=money(origLine,cur); pr.appendChild(s);
        }
        body.appendChild(pr);
        if(origLine>finalLine){
          var sv=document.createElement('span'); sv.className='mg-cart__item-save';
          sv.textContent=tSave+' '+money(origLine-finalLine,cur);
          body.appendChild(sv);
        }
        wrap.appendChild(img); wrap.appendChild(body);
        elItems.appendChild(wrap);
      });
      addonToggles.forEach(function(t){
        var vid=+t.getAttribute('data-variant-id');
        t.checked=!!addonLines[vid];
      });
      var savedTotal=0;
      cart.items.forEach(function(it){
        var h2=(it.handle||(it.url||'').split('/products/')[1]||'').split('?')[0].split('/')[0];
        var cmpUnit2=(cmpCache[h2]||{})[it.variant_id]||0;
        var origLine2=Math.max(it.original_line_price,cmpUnit2*it.quantity);
        var finalLine2=it.final_line_price;
        if(origLine2>finalLine2) savedTotal+=(origLine2-finalLine2);
      });
      if(elSave){ elSave.hidden=savedTotal<=0; if(elSaveV)elSaveV.textContent=money(savedTotal,cur) }
      if(elSubtotal)elSubtotal.textContent=money(cart.total_price,cur);
      if(elPay)elPay.href=root_+'checkout';
    }

    function refresh(){
      return fetch(root_+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(cart){return renderWithCompare(cart).then(function(){return cart})});
    }

    function changeLine(line,qty){
      if(busy)return; busy=true;
      fetch(root_+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:Math.max(0,qty)})})
        .then(function(r){return r.json()}).then(function(cart){return renderWithCompare(cart).then(function(){updateBubble(cart);busy=false})})
        .catch(function(){busy=false});
    }

    function toggleAddon(vid,on){
      if(busy)return; busy=true;
      var req=on
        ? fetch(root_+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:1}]})})
        : refresh().then(function(cart){
            var idx=cart.items.findIndex(function(it){return it.variant_id===vid});
            if(idx<0)return Promise.resolve();
            return fetch(root_+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:idx+1,quantity:0})});
          });
      req.then(function(){return refresh()}).then(function(cart){updateBubble(cart);busy=false}).catch(function(){busy=false});
    }

    addonToggles.forEach(function(t){
      t.addEventListener('change',function(){toggleAddon(+t.getAttribute('data-variant-id'),t.checked)});
    });

    function updateBubble(cart){
      var bubble=document.querySelector('.cart-count-bubble span[aria-hidden]');
      var icon=document.getElementById('cart-icon-bubble');
      if(!icon)return;
      if(cart.item_count>0){
        if(bubble)bubble.textContent=cart.item_count;
        else icon.insertAdjacentHTML('beforeend','<div class="cart-count-bubble"><span aria-hidden="true">'+cart.item_count+'</span></div>');
      } else {
        var b=icon.querySelector('.cart-count-bubble'); if(b)b.remove();
      }
    }

    function open(){
      refresh().then(function(){
        root.hidden=false; void root.offsetWidth; root.classList.add('on');
        document.body.classList.add('mg-cart-open');
        startTimer();
      });
    }
    function close(){
      root.classList.remove('on'); document.body.classList.remove('mg-cart-open');
      clearInterval(timer);
      setTimeout(function(){ if(!root.classList.contains('on'))root.hidden=true },350);
    }
    root.querySelectorAll('[data-mg-cart-close]').forEach(function(b){b.addEventListener('click',close)});
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&root.classList.contains('on'))close() });

    var cartIcon=document.getElementById('cart-icon-bubble');
    if(cartIcon){
      cartIcon.addEventListener('click',function(e){ e.preventDefault(); open() });
    }
    window.mgCarrito={open:open,close:close,refresh:refresh};
  }
  document.addEventListener('DOMContentLoaded',function(){initCuentaAtras();initReveal();initGaleria();initProducto();initAntesDespues();initVideos();initHeroSlider();initCarrito()});
})();
